// extracted by mini-css-extract-plugin
export default {"suggestionPending":"webpack-concepts-Extraction-Blocks-MultipleChoice-control-SuggestibleMultipleChoice-module__suggestionPending"};